import React, { useMemo, useRef, useEffect, useState } from 'react'
import { EmperorBread, EPostLikeInfo } from '../../models/constants'
import Bread from '../components/Breadcrumb'
import './index.less'
import { List } from 'antd'
import { effect, useStore, reducer } from '../../dva16'
import { NInfo, EGetInfo, RSetState, EGetHotSearch } from '../../models/constants'
import cheerio from 'cheerio'

import HotArticle from '../components/hotArticle'

const handleChangeCollectionStatus = (item) => {
  effect(NInfo, EPostLikeInfo, { id: parseInt(item.id), infoID: parseInt(item.id) })
}

function Emperor() {
  useMemo(() => {
    reducer(NInfo, RSetState, { categoryID: 3, topicID: null })
    effect(NInfo, EGetHotSearch, { categoryID: 3, isHot: 1 })
    effect(NInfo, EGetInfo)
  }, [])

  let { infoList, hotList } = useStore(NInfo)
  return (
    <div id="container">
      <div id="emperor">
        {Bread(EmperorBread)}
        <div className="center">
          <div className="left">
            <List
              itemLayout="vertical"
              className="list"
              size="large"
              pagination={{
                total: infoList.total,
                current: infoList.page,
                onChange: (page) => {
                  reducer(NInfo, RSetState, { categoryID: 3, pager: page })
                  effect(NInfo, EGetInfo)
                  sessionStorage.removeItem('categoryID3')
                  sessionStorage.setItem('categoryID3', page)
                },
                pageSize: infoList.perPage || 6,
              }}
              dataSource={infoList.data}
              renderItem={(item) => (
                <List.Item key={item.title}>
                  <div className="list-item">
                    <div className="img">
                      <img alt="logo" src={item.photos && item.photos[0]} />
                    </div>
                    <div className="foot">
                      <div
                        className="footcenter"
                        onClick={() => {
                          document.documentElement.scrollTop = document.body.scrollTop = 0
                          window.location.href = `#/detail/${item.id}`
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <div>{item.title}</div>
                        <div className="text" dangerouslySetInnerHTML={{ __html: cheerio.load(item.html).text() }}></div>
                      </div>
                      <div className="footicon">
                        <img src={require('../static/view.svg')} alt="" />
                        <span>{item.visitCount}</span>
                        <img src={require('../static/reply.svg')} alt="" />
                        <span>{item.commentCount}</span>
                        <img onClick={()=>{handleChangeCollectionStatus(item)}} src={item.myLike ? require('../static/like-2.svg') : require('../static/like.svg')} alt="" />
                        <span>{item.likeCount}</span>
                        <span>发布于：{item.createdAt}</span>
                      </div>
                    </div>
                  </div>
                </List.Item>
              )}
            />
          </div>
          <div className="right">
            <div
              onClick={() => {
                document.documentElement.scrollTop = document.body.scrollTop = 0
                window.location.href = '#/edit/3'
              }}
              className="edit"
            >
              <img src={require('../static/write-2.svg')} alt="" />
              <span>发帖</span>
            </div>
            {hotList ? HotArticle('热门帖', hotList.data) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Emperor
